import { useTranslation } from 'react-i18next'

import { MoreMenu } from '@/components/ui/MoreMenu'

/* The quote header's «⋯» menu (S-3): the three things on a quote that are about
 * it rather than part of the work on it — the revisions already issued, the
 * action log, and who is on the team. They were tabs beside the cargo and the
 * costing; on the one-sheet page they open in side sheets from here, so the
 * sheet is the work and nothing else.
 *
 * The control itself is the shared `MoreMenu` (extracted in S-11, when the case
 * header grew one); this names the quote's three items and their counts. */

export type QuoteMorePanel = 'revisions' | 'history' | 'team'

export function QuoteMoreMenu({
  revisions,
  team,
  onOpen,
}: {
  /** How many revisions have been issued. */
  revisions: number
  /** How many colleagues are on the quote. */
  team: number
  onOpen: (panel: QuoteMorePanel) => void
}) {
  const { t } = useTranslation()

  return (
    <MoreMenu
      label={t('quotes.more.label')}
      items={[
        { key: 'revisions', label: t('quotes.more.revisions', { n: revisions }) },
        { key: 'history', label: t('quotes.more.history') },
        { key: 'team', label: t('quotes.more.team', { n: team }) },
      ]}
      onSelect={onOpen}
    />
  )
}
